import Btn from "@mui/material/Button";
import Typography from "@mui/material/Typography";

function Button({
  children,
  variant,
  sx,
  size,
  bgColor,
  txColor,
  outColor,
  typoVariant,
  typoSize,
  startIcon,
  endIcon,
  onClick,
  hoverBg,
  hoverTxColor,
  fontWeight = "600",
}) {
  const isLg = size === "lg";
  const contained = variant === "contained";

  return (
    <Btn
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      sx={{
        backgroundColor: bgColor,
        borderRadius: "4px",
        borderWidth: !contained && "1px",
        borderColor: !contained && outColor ? outColor : txColor,
        padding: "8px 16px",
        "&:hover": {
          backgroundColor: hoverBg,
          boxShadow: "none",
          borderColor: !contained && outColor ? outColor : txColor,
          // "& .MuiSvgIcon-root": {
          //   fill: "white",
          // },
        },
        "&:hover h6": {
          color: hoverTxColor,
        },
        "&:hover span": {
          color: hoverTxColor,
        },
        "&:hover p": {
          color: hoverTxColor,
        },
        ...sx,
      }}
    >
      <Typography
        variant={typoVariant}
        sx={{
          color: txColor,
          fontSize: typoSize ? typoSize : isLg ? "16px" : "14px",
          fontWeight: fontWeight,
          lineHeight: isLg ? "24px" : "20px",
          textAlign: "center",
          textTransform: "none",
        }}
      >
        {children}
      </Typography>
    </Btn>
  );
}

export default Button;
